/* eslint-disable react/prop-types */
/* eslint-disable react/no-unused-state */
/* eslint-disable react/destructuring-assignment */
import React from 'react';

// NOTE: React doesn't have functional way for error boundaries
class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { error: null, errorInfo: null };
	}

	componentDidCatch(error, errorInfo) {
		// Catch errors in any components below and re-render with error message
		this.setState({
			error,
			errorInfo,
		});
	}

	render() {
		if (this.state.errorInfo) {
			return <small>Something went wrong.</small>;
		}

		// Normally, just render children
		return this.props.children;
	}
}

export default ErrorBoundary;
